import React, { FC, useState, useEffect } from 'react';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import SearchIcon from '@mui/icons-material/Search';

interface FilterBarProps {
  filters: any;
  controller: string;
  clearedFilterSetting: any;
  filterValues: any;
  fetchRecordsList: any;
  setFilterValues: any;
  setPage: any;
  setSortParam: any;
  searchQuery: any;
  setSearchQuery: any;
  queryPlaceholder: any;
}

const FilterBar: FC<FilterBarProps> = (props) => {
  let {
    filters,
    controller,
    clearedFilterSetting,
    filterValues,
    fetchRecordsList,
    setFilterValues,
    setPage,
    setSortParam,
    searchQuery,
    setSearchQuery,
    queryPlaceholder,
  } = props;

  const [localQuery, setLocalQuery] = useState<string>('');

  useEffect(() => {
    setLocalQuery(searchQuery);
  }, [searchQuery]);

  const handleClear = () => {
    setPage(1);
    setSortParam('');
    setFilterValues(clearedFilterSetting);
    setSearchQuery('');
    fetchRecordsList(controller, clearedFilterSetting, 1, '', '');
  };

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>{filters}</Grid>
      <Grid item alignItems="center" style={{ marginTop: -5 }}>
        <Button variant="contained" color="info" className="tertiary-btn" onClick={handleClear}>
          Clear
        </Button>
      </Grid>
    </Grid>
  );
};

export default FilterBar;
